import * as actions from "../actions/AdminMenuActions";
import { AdminMenuState, initialState } from "../store/AdminMenuState";
import buildReducer from "../utils/ReducerBuilder";

export const AdminMenuReducer = buildReducer<AdminMenuState>(initialState)
    .handle(actions.toggleOpen, (state, action) => ({
        ...state,
        open: action.payload || false,
    }))
    .done();



// WEBPACK FOOTER //
// ./src/reducers/AdminMenuReducer.ts